import { routerStyxie } from '@/router/styxieBridge'
import { useMlapProjectStore } from '@/stores/mlapProject'
import { useMlapProjectPagesStore } from '@/stores/mlapProjectPages'

// Client-side routed under the project layout. The location is keyed by id in
// the route `prepare`, so it is seeded without the one-shot hydration flag.
Styxie.Initializers.MlapProjectsLocations = routerStyxie({
  actions: ['show'],
  hydrate: (props, pinia) => {
    useMlapProjectStore(pinia).hydrate(props.project)
    useMlapProjectPagesStore(pinia).setPage('location', props.location)
  }
})
